import { Box } from '@opendoor/bricks-next';
import { Link } from '@opendoor/bricks/core';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';

import { EntryComponent } from '../../cms/entries/entries';
import { IComponentImageAssetLink, IImageAsset } from '../../declarations/contentful';
import ImageAsset from './ImageAsset';

const renderImageLink = (entry: IComponentImageAssetLink) => {
  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }}>
      <ThemedLite theme="legacy">
        <Link
          href={entry?.fields?.uri}
          target="_blank"
          analyticsName="cosmos-articles-image"
          aria-label=""
        >
          {ImageAsset.render(entry.fields.image as IImageAsset)}
        </Link>
      </ThemedLite>
    </Box>
  );
};

const ImageAssetLink: EntryComponent<IComponentImageAssetLink> = {
  render: renderImageLink,
};

export default ImageAssetLink;
